export default __webpack_public_path__ + "static/media/eye-open.d2943336.svg";